module.exports = __webpack_public_path__ + "static/media/cw.c2c720ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cw.svg
// module id = 94
// module chunks = 0